module.exports = __webpack_public_path__ + "static/media/47-active.5d982070.png";